import React from "react";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import translate from "../../../i18n/translate";
import { useHistory } from "react-router-dom";
import TextFieldGroup from "./../../common/TextFieldGroup";
import "./jawwal.css";
import credits, { EMPTY_CREDIT } from "./credits";
import SubNav from "./SubNav";
import Selected from "./Selected";
import CompaniesNav from "../../common/CompaniesNav";
import logo from "../../../assests/images/bundles/jawwal/banner.jpg";
import { jsonParser } from "shared/utils/ppUtils";
import { border, color } from "@mui/system";
import Notiflix from "notiflix";

const MAX_JAWWAL_CARDS = 3;

const JawwalCredit = ({ isDarktheme }) => {
  const history = useHistory().location.pathname;
  const state = useHistory().location.state;
  const [price, setPrice] = useState(null);
  const [selected, setSelected] = useState({});
  const [creditQueue, setCreditQueue] = useState([]);
  const [jawwal3g, setJawwal3g] = useState("");
  const [jawwalRom, setJawwalRom] = useState("");
  const [jawwalMin, setJawwalMin] = useState("");
  const [columnStyle, setColumnStyle] = useState(
    "col-lg-3 col-md-4 col-sm-6 col-6"
  );
  const [plus, setPlus] = useState("");

  const dispatchSessionStorageEvent = () => {
    try {
      window.dispatchEvent(new Event("sessionStorageChanged"));
    } catch (error) {
      // ignore dispatch errors
    }
  };

  const persistCreditQueue = (queue) => {
    if (queue?.length) {
      sessionStorage.JawwalCreditQueue = JSON.stringify(queue);
      sessionStorage.JawwalCredit = JSON.stringify(
        queue[queue.length - 1] || {}
      );
    } else {
      sessionStorage.removeItem("JawwalCreditQueue");
      sessionStorage.removeItem("JawwalCredit");
    }
    dispatchSessionStorageEvent();
  };

  const handleCreditQueueChange = (queue) => {
    const normalizedQueue = (queue || []).map((item, index) => ({
      ...item,
      type: item?.type || "credit",
      __uid:
        item?.__uid ||
        `${item?.id || "credit"}-${index}-${Date.now().toString(36)}`,
    }));
    setCreditQueue(normalizedQueue);
    setSelected(normalizedQueue[normalizedQueue.length - 1] || {});
    persistCreditQueue(normalizedQueue);
  };

  const addCreditToQueue = (creditItem, sourceElement) => {
    if (!creditItem) {
      return;
    }

    const amountValue = Number(creditItem.price);
    if (!creditItem.price || Number.isNaN(amountValue) || amountValue <= 0) {
      Notiflix.Notify.warning(
        translate("Please enter a valid credit amount first.")
      );
      return;
    }

    const enrichedCredit = {
      ...creditItem,
      price: creditItem.price,
      type: creditItem.type || "credit",
      __uid:
        creditItem.__uid ||
        `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`,
    };

    if (creditQueue.length >= MAX_JAWWAL_CARDS) {
      Notiflix.Notify.warning(
        translate("You can select up to 3 cards per payment.")
      );
      return;
    }

    const updatedQueue = [...creditQueue, enrichedCredit];
    handleCreditQueueChange(updatedQueue);

    if (window.triggerBundleAnimation && sourceElement) {
      window.triggerBundleAnimation("credit", sourceElement);
    }
  };

  let routerMobileNo = history.split("/")[3];

  useEffect(() => {
    const handleSessionStorageChange = () => {
      document.title = "Credit Jawwal | Phone Play";

      const storedQueueRaw =
        sessionStorage.JawwalCreditQueue || sessionStorage.JawwalCredit;
      const parsedQueue = jsonParser(storedQueueRaw);
      if (Array.isArray(parsedQueue) && parsedQueue.length) {
        handleCreditQueueChange(parsedQueue);
      } else if (parsedQueue) {
        handleCreditQueueChange([parsedQueue]);
      } else {
        if (creditQueue.length || selected?.price) {
          setCreditQueue([]);
          setSelected({});
        }
        sessionStorage.removeItem("JawwalCreditQueue");
        sessionStorage.removeItem("JawwalCredit");
      }

      if (sessionStorage.JawwalMin) {
        setJawwalMin(jsonParser(sessionStorage.JawwalMin));
      }
      if (sessionStorage.Jawwal3g) {
        setJawwal3g(jsonParser(sessionStorage.Jawwal3g));
      }
      if (sessionStorage.JawwalRom) {
        setJawwalRom(jsonParser(sessionStorage.JawwalRom));
      }
      if (sessionStorage.JawwalPlus) {
        setPlus(jsonParser(sessionStorage.JawwalPlus));
      }
      refreshColumnStyle();
    };
    handleSessionStorageChange();

    window.addEventListener(
      "sessionStorageChanged",
      handleSessionStorageChange
    );

    // Clean up the event listener
    return () => {
      window.removeEventListener(
        "sessionStorageChanged",
        handleSessionStorageChange
      );
    };
  }, [history]);

  const onChange = (e) => {
    const value = e.target.value;
    if (value.includes(".") || value.includes(",")) {
      e.target.value = Math.floor(value);
    }
    const selectedCredit = { ...EMPTY_CREDIT, price: e.target.value };
    setPrice(e.target.value);
    setSelected(selectedCredit);
  };

  const onTypeClick = (item, event) => {
    const clickedCard = event?.currentTarget;
    window.bundleAnimationTriggered = false;
    addCreditToQueue(item, clickedCard);
    document
      .getElementsByTagName("html")[0]
      .scrollIntoView({ behavior: "smooth" });
  };

  const refreshColumnStyle = () => {
    switch (localStorage.size) {
      case "default":
        setColumnStyle("col-lg-3 col-md-4 col-sm-6 col-6");
        break;
      case "column3":
        setColumnStyle("col-lg-4 col-md-6 col-sm-6 col-6 card-lg");
        break;
      case "column4":
        setColumnStyle("col-lg-3 col-md-4 col-sm-6 col-6 card-md");
        break;
      case "column6":
        setColumnStyle("col-lg-2 col-md-2 col-sm-4 col-6 card-sm");
        break;
      default:
        setColumnStyle("col-lg-3 col-md-4 col-sm-6 col-6");
    }
  };
  let topDiv = null;

  return (
    <>
      <div ref={(ref) => (topDiv = ref)}>
        <div className="">
          <CompaniesNav
            title="Jawwal"
            logo={logo}
            mobile={routerMobileNo}
            onRefresh={() => { }}
            actionWidth="130px"
            providerId={
              window?.history?.state?.state?.provider_Id
                ? window?.history?.state?.state?.provider_Id
                : state?.provider_id
            }
            backLink="/company/jawwalNo"
            comingFromReports={
              !window?.history?.state?.state?.provider_Id && state?.provider_id
            }
            credit={selected}
          />
          <div className="row">
            <div className="col-12">
              <SubNav mobile={history.split("/")[3]} />
            </div>
          </div>
          <div className="position-relative">
            <Selected
              min={jawwalMin}
              setMin={setJawwalMin}
              g3={jawwal3g}
              setg3={setJawwal3g}
              credit={selected}
              setCredit={setSelected}
              creditQueue={creditQueue}
              onCreditQueueChange={handleCreditQueueChange}
              setRom={setJawwalRom}
              rom={jawwalRom}
              setPlus={setPlus}
              plus={plus}
            />

            <hr
              className="mt-3"
              style={{
                border: "2px solid #42ace3",
                backgroundColor: "#42ace3",
                fontWeight: "bolder",
              }}
            />

            <div className="row ">
              <div className={`${columnStyle} my-2`}>
                <div className="card card-credit">
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={(e) =>
                      onTypeClick({ ...EMPTY_CREDIT, price: price }, e)
                    }
                  >
                    <div className="card">
                      <img
                        alt=""
                        src={EMPTY_CREDIT.url}
                        width="260px"
                        height="100px"
                        loading="eager"
                        decoding="sync"
                      ></img>
                      <TextFieldGroup
                        style={{
                          width: "calc(50% - 20px)",
                          height: "70%",
                          padding: 0,
                          position: "absolute",
                          top: "50%",
                          left: "calc(50% + 12px)",
                          transform: "translateY(-50%)",
                          fontSize: "2rem",
                          fontFamily: '"Montserrat", sans-serif',
                          textAlign: "center",
                          outline: "rgb(16, 16, 16) auto 4px",
                          color: "#14c259",
                          boxShadow: "none", // Prevent focus shadow
                        }}
                        // inputProps={{
                        //   style: {
                        //     border: "transparent",
                        //     outline: "none",
                        //     boxShadow: "none",
                        //   },
                        // }}
                        name="price"
                        type="number"
                        pattern="\d+"
                        onChange={onChange}
                        min={10}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {credits.map((item, i) => (
                <div key={i.toString()} className={`${columnStyle} my-2`}>
                  <div className="charge-card" id="bundle-card-container">
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={(e) => onTypeClick(item, e)}
                      id="bundle-card-clicker"
                    >
                      <div className="card">
                        <img
                          alt=""
                          src={item.url}
                          width="260px"
                          height="100px"
                          loading="eager"
                          decoding="sync"
                        ></img>
                        {item && item.des}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  loading: state.companies.loading,
  isDarktheme: state.darkTheme.isDarktheme,
});

export default connect(mapStateToProps)(JawwalCredit);
